var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { class: _vm.sectionClass }, [
    _c("div", { staticClass: "section-content" }, [
      _c("div", { staticClass: "has-text-centered" }, [
        _c("div", { staticClass: "title is-spaced is-spaced-bottom" }, [
          _vm._v(_vm._s(_vm.$t("home.title4"))),
        ]),
      ]),
      _c("div", { staticClass: "columns column-text-center is-vcentered" }, [
        _c("div", { staticClass: "column is-7-desktop is-8-tablet" }, [
          _c("strong", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.$t("home.subtitle4_1"))),
          ]),
          _c(
            "p",
            {
              staticClass:
                "subtitle no-line-break-mobile subtitle-right-padding",
            },
            [_vm._v(_vm._s(_vm.$t("home.content4_l1_1") + " "))]
          ),
        ]),
        _vm._m(0),
      ]),
      _c("div", { staticClass: "columns column-text-center is-vcentered" }, [
        _vm._m(1),
        _c("div", { staticClass: "column is-7-desktop is-8-tablet" }, [
          _c("strong", { staticClass: "subtitle subtitle-left-padding" }, [
            _vm._v(_vm._s(_vm.$t("home.subtitle4_2"))),
          ]),
          _c(
            "p",
            {
              staticClass:
                "subtitle no-line-break-mobile subtitle-left-padding",
            },
            [_vm._v(_vm._s(_vm.$t("home.content4_l2_1") + " "))]
          ),
        ]),
      ]),
      _c("div", { staticClass: "columns column-text-center is-vcentered" }, [
        _c("div", { staticClass: "column is-7-desktop is-8-tablet" }, [
          _c("strong", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.$t("home.subtitle4_3"))),
          ]),
          _c(
            "p",
            {
              staticClass:
                "subtitle no-line-break-mobile subtitle-right-padding",
            },
            [_vm._v(_vm._s(_vm.$t("home.content4_l3_1") + " "))]
          ),
        ]),
        _vm._m(2),
      ]),
      _c("div", { staticClass: "columns column-text-center is-vcentered" }, [
        _vm._m(3),
        _c("div", { staticClass: "column is-7-desktop is-8-tablet" }, [
          _c("strong", { staticClass: "subtitle subtitle-left-padding" }, [
            _vm._v(_vm._s(_vm.$t("home.subtitle4_4"))),
          ]),
          _c(
            "p",
            {
              staticClass:
                "subtitle no-line-break-mobile subtitle-left-padding",
            },
            [_vm._v(_vm._s(_vm.$t("home.content4_l4_1") + " "))]
          ),
        ]),
      ]),
      _c("div", { staticClass: "columns column-text-center is-vcentered" }, [
        _c("div", { staticClass: "column is-7-desktop is-8-tablet" }, [
          _c("strong", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.$t("home.subtitle4_5"))),
          ]),
          _c(
            "p",
            {
              staticClass:
                "subtitle no-line-break-mobile subtitle-right-padding",
            },
            [_vm._v(_vm._s(_vm.$t("home.content4_l5_1") + " "))]
          ),
        ]),
        _vm._m(4),
      ]),
      _c("div", { staticClass: "columns column-text-center is-vcentered" }, [
        _vm._m(5),
        _c("div", { staticClass: "column is-7-desktop is-8-tablet" }, [
          _c("strong", { staticClass: "subtitle subtitle-left-padding" }, [
            _vm._v(_vm._s(_vm.$t("home.subtitle4_6"))),
          ]),
          _c(
            "p",
            {
              staticClass:
                "subtitle no-line-break-mobile subtitle-left-padding",
            },
            [_vm._v(_vm._s(_vm.$t("home.content4_l6_1") + " "))]
          ),
        ]),
      ]),
      _c("div", { staticClass: "columns column-text-center is-vcentered" }, [
        _c("div", { staticClass: "column is-7-desktop is-8-tablet" }, [
          _c("strong", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.$t("home.subtitle4_7"))),
          ]),
          _c(
            "p",
            {
              staticClass:
                "subtitle no-line-break-mobile subtitle-right-padding",
            },
            [_vm._v(_vm._s(_vm.$t("home.content4_l7_1") + " "))]
          ),
        ]),
        _vm._m(6),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3-desktop is-3-tablet" }, [
      _c("img", {
        staticClass: "features-phone",
        attrs: { src: "/img/features/phone-lesson.png" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3-desktop is-3-tablet" }, [
      _c("img", {
        staticClass: "features-phone",
        attrs: { src: "/img/features/phone-workout.png" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3-desktop is-3-tablet" }, [
      _c("img", {
        staticClass: "features-phone",
        attrs: { src: "/img/features/phone-colleagues.png" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3-desktop is-3-tablet" }, [
      _c("img", {
        staticClass: "features-phone",
        attrs: { src: "/img/features/phone-achievement.png" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3-desktop is-3-tablet" }, [
      _c("img", {
        staticClass: "features-phone",
        attrs: { src: "/img/features/phone-ranking.png" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3-desktop is-3-tablet" }, [
      _c("img", {
        staticClass: "features-phone",
        attrs: { src: "/img/features/phone-profile.png" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3-desktop is-3-tablet" }, [
      _c("img", {
        staticClass: "features-phone",
        attrs: { src: "/img/features/phone-blog.png" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }